import React, { useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { OAuthCtx } from "../../auth/AuthContext";
import { setupAuthInterceptor } from "../../utils/apis";
import { saveTargetPath } from "../../utils/storage";
import Loading from "../UI/Loading";
import { useDispatch, useSelector } from "react-redux";
import {
  customGoogleUserLogin,
  GetUserLoginType,
} from "../common/GlobalFunction";
import { setUserStatus } from "../../redux/action/user";
import { Auth } from "aws-amplify";
import { useFeatureFlag } from "@harnessio/ff-react-client-sdk";
import { setLoading } from "../../redux/action/loadingRequest";

const ProtectedRoute = ({ children }) => {
  const { getAuthState } = useContext(OAuthCtx);
  const location = useLocation();
  const dispatch = useDispatch();

  const loading = useSelector((state) => state?.LoadingReducer?.state || false);
  const userType = GetUserLoginType();
  const type = useSelector((state) => state.userReducer?.type) || "copy-link";
  const isLoggedIn =
    useSelector((state) => state?.userReducer?.isLoggedIn) || false;

  setupAuthInterceptor(getAuthState);
  const viewAsRecruiter = useSelector(
    (state) => state.userReducer.viewAsRecruiter
  );

  // Check if the user is trying to access /all-elements/:id while not logged in
  // Store the ID and path for redirect after login
  React.useEffect(() => {
    if (!isLoggedIn) {
      const pathMatch = location.pathname.match(/^\/all-elements\/([^/]+)/);
      const currentUrl = window.location.href;
      const hasSource = currentUrl.includes("&source=cvscore");
      if (hasSource) {
        dispatch(setLoading(true));
        const currentUrl = window.location.href;
        const updatedUrl = currentUrl.replace(/&source=[^&]*/, "");

        // Update URL without page reload
        if (updatedUrl !== currentUrl) {
          window.history.replaceState({}, "", updatedUrl);
        }
        const allElementsId = pathMatch[1];
        const fullPath = location.pathname + location.search;
        const cleanPath = location.pathname.split('&')[0];
        // Store in localStorage for persistence across sessions
        localStorage.setItem("pendingAllElementsId", allElementsId);
        localStorage.setItem("pendingAllElementsPath", cleanPath);
        // Also store in sessionStorage for immediate use
        saveTargetPath(cleanPath);

        // If there's a cvscore parameter, prioritize this redirect
        if (location.search.includes('cvscore')) {
          localStorage.setItem("priorityAllElementsRedirect", "true");
        }
      } 
      // For other paths, just save to sessionStorage
      // saveTargetPath(location.pathname + location.search);
    }  

  }, [location, isLoggedIn]);

  const Admin_Access = useFeatureFlag("Admin_Access");

  // Check if Admin_Access is valid JSON or fall back to an empty array
  let allowedEmails = [];
  try {
    if (Admin_Access) {
      allowedEmails = JSON.parse(Admin_Access);
    }
  } catch (error) {
    console.error("Error parsing Admin_Access:", error);
  }

  useEffect(() => {
    if (isLoggedIn === false) {
      dispatch(setLoading(true));
      console.log("CALLED1");
    }
    else if (isLoggedIn === true) (
      dispatch(setLoading(false))
    )
    const checkSession = async () => {
      try {
        const currentSession = await Auth.currentSession();
        const hasLoggedIn = sessionStorage.getItem("hasLoggedIn") || false;
        const uniqueReferredUserId = sessionStorage.getItem(
          "uniqueReferredUserId"
        );

        if (currentSession) {
          let viewAsRecruiterState =
            viewAsRecruiter === undefined
              ? sessionStorage.getItem("viewAsRecruiter") === "true"
                ? true
                : false
              : viewAsRecruiter;
          if (!hasLoggedIn) {
            customGoogleUserLogin(
              dispatch,
              uniqueReferredUserId,
              type,
              setLoading,
              viewAsRecruiterState
            );
            sessionStorage.setItem("hasLoggedIn", true);
            console.log("CALLED2");

            // dispatch(setLoading(false));
          }
          else {
            dispatch(
              setUserStatus({
                isLoggedIn: true,
                userRefId: sessionStorage.getItem("userRefId"),
                uniqueReferredUserId: uniqueReferredUserId,
                viewAsRecruiter: viewAsRecruiter,
              })
            );

            // Check if user is already logged in and needs to be redirected to all-elements
            const pendingAllElementsPath = localStorage.getItem("pendingAllElementsPath");
            const priorityRedirect = localStorage.getItem("priorityAllElementsRedirect");

            if (pendingAllElementsPath) {
              // Clear the stored values
              localStorage.removeItem("pendingAllElementsId");
              localStorage.removeItem("pendingAllElementsPath");
              localStorage.removeItem("priorityAllElementsRedirect");

              // Redirect to the stored all-elements path
              setTimeout(() => {
                window.location.href = pendingAllElementsPath;
              }, priorityRedirect === "true" ? 50 : 100); // Faster redirect for cvscore
              return;
            }
          }
        } else {
          localStorage.clear();
          sessionStorage.clear();
          dispatch(
            setUserStatus({
              isLoggedIn: false,
              userRefId: sessionStorage.getItem("userRefId"),
              uniqueReferredUserId: uniqueReferredUserId,
              viewAsRecruiter: viewAsRecruiter,
            })
          );
          // saveTargetPath("/signin");
        }
      } catch (error) {
        // console.log("CALLED2");
        if (window.location.pathname !== "/") {
          window.location.replace("/signin");
        }
        dispatch(setLoading(false));
        // saveTargetPath("/signin");

        console.error("Error updating login time:", error);
      }
    };

    checkSession();
  }, [dispatch, userType, type]);

  if (loading) {
    return <Loading />;
  }

  return children;
};

export default ProtectedRoute;
